function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135mm",
    height: "5mm",
    viewBox: "0 0 135 5",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 0.264583
    },
    id: "path854",
    d: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: "0.264583px",
      InkscapeStroke: "none"
    },
    d: "m 4.739361,2.5 h 59.45954",
    id: "path3156"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M 4.739669,2.36809 V 2.63176 H 64.198653 V 2.36809 Z",
    id: "path3158"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: "0.264583px",
      InkscapeStroke: "none"
    },
    d: "M 70.801094,2.5 H 130.26064",
    id: "path3148"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M 70.800216,2.36809 V 2.63176 H 130.26115 V 2.36809 Z",
    id: "path3150"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 0.743789,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 67.500056,0.0523473 0.999998,0.9999975 -1,0.9999996 -0.999997,-0.9999975 z",
    id: "rect1229-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 0.743789,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 68.947652,1.4999434 0.999998,0.9999975 -1,0.9999996 -0.999997,-0.9999975 z",
    id: "rect1229-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 0.743789,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 66.052352,1.5000516 0.999997,0.9999974 -1,1.0000003 -0.999997,-0.9999974 z",
    id: "rect1229-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 0.743789,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M 67.499948,2.9476476 68.499946,3.9476451 67.499945,4.9476454 66.499948,3.9476479 Z",
    id: "rect1229-7-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 1.065,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M 3.2006029,1.7928899 3.9077097,2.4999967 3.2006029,3.2071035 2.4934961,2.4999967 Z",
    id: "rect2360"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 0.503497,
      stroke: "none",
      strokeWidth: 1.065,
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M 131.7994,1.7928864 132.50651,2.4999932 131.7994,3.2071 131.09229,2.4999932 Z",
    id: "rect2360-8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossline);
export default __webpack_public_path__ + "static/media/crossline.410c5df72a961cb3e67a64d554a70992.svg";
export { ForwardRef as ReactComponent };